'use strict';

angular.module('shiftTraderApp')
    .controller('AvailabilityManagementNewRequestCtrl', function($scope, AvailabilityRules, TimeService,
                                                       $state, $stateParams, $location,
                                                       SAErrorHandler, me, org, toastr,
                                                       Session, AvailabilityChangeRequests) {
      $scope.me = me;
      $scope.org = org;
      //$scope.availabilityChangeRequests = AvailabilityChangeRequests.getAll({organization_id: org.id});

      $scope.allDepartments = $scope.org.departments;

      $scope.nowDate = TimeService.getNowInStoreTime();
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.formData = {
        expires_at: TimeService.getBeginningOfDayFromDate(moment().add(7, 'days')).toDate(),
        effective_date: TimeService.getBeginningOfDayFromDate(moment().add(10, 'days')).toDate(),
        message: '',
        approval_required: true
      };

      $scope.state = {
      };

    $scope.placeholder = 'Next semester is right around the corner! Please submit your new availability. We typically have a hard time scheduling Tuesday morning so any help is appreciated!';

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      minDate: $scope.dateToday,
      showWeeks: false
    };

    $scope.datepickers = {
      effectiveDateOpened: false
    };

    $scope.openEffectiveDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.effectiveDateOpened === true) {
        $scope.datepickers.effectiveDateOpened = false;
      } else {
        $scope.datepickers.effectiveDateOpened = true;
      }
    };

    $scope.openExpiresAtDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.expiresAtDateOpened === true) {
        $scope.datepickers.expiresAtDateOpened = false;
      } else {
        $scope.datepickers.expiresAtDateOpened = true;
      }
    };

    $scope.minDate = new Date(moment().hours(0).minutes(0).seconds(0).milliseconds(0).add(moment().tz(Session.getTimezone())._offset, 'minutes').format('YYYY-MM-DD hh:mm'));

    //:organization_id, :expires_at, :effective_date, :message, :approval_required

    $scope.createChangeRequest = function() {
      var createData = {
        organization_id: $scope.org.id,
        expires_at: TimeService.getBeginningOfDayFromDate(moment($scope.formData.expires_at)).toISOString(),
        effective_date: TimeService.getBeginningOfDayFromDate(moment($scope.formData.effective_date)).toISOString(),
        message: $scope.formData.message,
        approval_required: $scope.formData.approval_required
      };

      console.log(createData);
      AvailabilityChangeRequests.create(createData)
        .then(function(acr) {
          toastr.success('Availability Change Request created!', 'Success');
          $state.go('^.list', {}, {reload: true});
        }, function() {
          toastr.error('Availability Change Request creation failed. Please try again.', 'Error');
        });
    };

    });
